<template>
  <div>
    <div class="pa-6">
      <v-container fluid>
        <v-row>
          <v-col class="yCenter">
            <h2 class="primary--text pr-5">商品毎の統計データ</h2>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col>
            <ExpansionPanel :open="true" @change="opnePanel">
              <template #header>
                <div class="searchAreaStyle d-flex align-center">
                  <div class="titleStyle font-weight-bold pl-10">
                    統計データ出力
                  </div>
                  <span class="d-flex align-center">
                    <div class="original-selectbox selectBoxStyle">
                      <NormalCombobox
                        v-model="year"
                        :items="yearSelectBoxInfo.yearList"
                        height="32px"
                      />
                    </div>
                  </span>
                </div>
              </template>
              <template #content>
                <div class="searchAreaStyle d-flex align-center">
                  <div class="honbunStyle pl-10">仕入先</div>
                  <span class="d-flex align-center">
                    <div class="original-selectbox selectBoxStyle">
                      <NormalCombobox
                        v-model="selectClientName"
                        :items="selectBoxInfo.clientNameList"
                        height="32px"
                      />
                    </div>
                  </span>
                </div>
                <div class="searchAreaStyle d-flex align-center">
                  <div class="honbunStyle2 pl-10">商品名</div>
                  <span class="d-flex align-center">
                    <div class="original-selectbox selectBoxStyle2">
                      <MultipleCombobox
                        v-model="selectProductName"
                        :items="productSelectBoxInfo.productNameList"
                        height="32px"
                      />

                    </div>
                  </span>
                </div>
                <v-layout>
                  <WhiteButton
                    class="input-form-button-left"
                    :text="$t('common.common_csv-download')"
                    height="50px"
                    width="130px"
                    textSize="16px"
                    @click="outputKpiCsv"
                  />
                  <NormalButton
                    class="input-form-button"
                    :text="$t('common.common_output')"
                    height="50px"
                    width="130px"
                    textSize="16px"
                    @click="outputKpi"
                  />
                </v-layout>
                
              </template>
            </ExpansionPanel>
          </v-col>
        </v-row>

        <v-row class="row-contents">
          <v-col v-if="isShowChart">
            <ChartForKpi
              :aggregateList="aggregateList"
              :supplierName="selectClientName.label"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { currencyUtil } from '@/util'

import {
  ExpansionPanel,
  WhiteButton,
  NormalButton,
  NormalTextButton,
  NormalCombobox,
  MultipleCombobox
} from '@/components/items'

import ProductSearch from '@/components/layouts/ProductSearchArea/ProductSearchAreaOrder'
import ProductInfo from '@/components/layouts/ProductInfo/Order/ProductInfo'

import ChartForKpi from '@/components/layouts/Kpi/ChartForKpi'

export default {
  name: 'Customers',

  components: {
    ChartForKpi,
    ExpansionPanel,
    WhiteButton,
    NormalButton,
    NormalTextButton,
    NormalCombobox,
    MultipleCombobox,

    ProductSearch,
    ProductInfo
  },
  data: () => {
    return {
      pageTitle: 'common.input_new-order',

      pageType: {
        en: 'kpi',
        ja: '統計データ'
      },

      clientAreaInfo: {
        isOpen: false,
        isSelect: false,
        selectInfo: {}
      },
      selectCurrency: { currencyId: null, name: '', unitName: '' },

      year: {
        label: '',
        value: null
      },
      yearSelectBoxInfo: {
        target: 'common.common_year',
        yearList: []
      },
      selectClientName: {
        label: '',
        value: null
      },
      selectBoxInfo: {
        target: 'product.product_supplier',
        clientId: 'supplierId',
        clientNameList: []
      },
      selectProductName: [],
      productSelectBoxInfo: {
        target: 'product.product_name',
        productId: 'productId',
        productNameList: []
      },
      aggregateList: [],
      aggregateListTmp: [],
      isShowChart: false
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapActions('Common', ['getCountryListFromApi']),
    ...mapActions('Supplier', ['getSuppliersFromApi']),
    ...mapGetters('Supplier', ['getSuppliersFromState']),
    ...mapActions('Order', ['getOrderListFromApi']),
    ...mapGetters('Order', ['getOrderListFromState']),
    ...mapActions('Product', ['getProductListFromApi']),
    ...mapGetters('Product', ['getProductListFromState']),
    ...mapActions('Kpi', [
      'getAggregateDataFromApi',
      'getAggregateDataLedgerSheet'
    ]),
    ...mapGetters('Kpi', ['getAggregateDataFromState']),

    opnePanel(...args) {
      const [index] = args
      this.clientAreaInfo.isOpen = index.length > 0
    },

    getHistoryListFromState() {
      return this.getOrderListFromState()
    },
    getClientListFromState() {
      return this.getSuppliersFromState()
    },

    async getClientData(isHistorySearch, selectClientNameValue) {
      return await Promise.all([
        this.getSuppliersFromApi(),
        isHistorySearch
          ? this.getOrderListFromApi({
              invalidOrderDisplay: 0,
              supplierIds: selectClientNameValue
            })
          : null
      ]).then((message) => {
        return [
          this.getClientListFromState().map((ele) => {
            return {
              label: ele.name,
              value: ele[this.selectBoxInfo.clientId]
            }
          }),
          isHistorySearch ? this.getHistoryListFromState() : []
        ]
      })
    },
    async getProductData() {
      return await Promise.all([this.getProductListFromApi()]).then(
        (message) => {
          return [
            this.getProductListFromState().map((ele) => {
              return {
                label: ele.nameJp,
                value: ele[this.productSelectBoxInfo.productId],
                supplierId: ele.supplierId
              }
            })
          ]
        }
      )
    },
    async init(isHistorySearch) {
      // 現在年を取得し、年度リスト作成
      const currentYear = new Date().getFullYear()
      const yearList = []
      for (var i = 0; i < 10; i++) {
        const tmpYear = currentYear - i
        yearList.push({
          label: String(tmpYear),
          value: tmpYear
        })
      }
      this.yearSelectBoxInfo.yearList = yearList
      this.year = {
        label: String(currentYear),
        value: currentYear
      }

      const [clientNameList, historyList] = await this.getClientData(
        isHistorySearch,
        this.selectClientName.value
      )
      const productNameList = await this.getProductData()
      this.selectBoxInfo.clientNameList = clientNameList
      this.productSelectBoxInfo.productNameList = productNameList[0]
    },
    async outputKpi() {
      if (this.year.value == null) {
        alert('年度を選択してください。')
        return
      }
      if (this.selectClientName.value == null) {
        alert('仕入先を選択してください。')
        return
      }
      const selectProductId = this.selectProductName.map((element) => {
        return element.value
      })
      this.isShowChart = false
      await this.getAggregateDataFromApi({
        params: {
          year: this.year.value,
          supplierId: this.selectClientName.value,
          productIds: selectProductId ?? []
        }
      })
      this.aggregateList = this.getAggregateDataFromState()
      this.isShowChart = true
    },
    async outputKpiCsv() {
      if (this.year.value == null) {
        alert('年度を選択してください。')
        return
      }
      if (this.selectClientName.value == null) {
        alert('仕入先を選択してください。')
        return
      }
      const selectProductId = this.selectProductName.map((element) => {
        return element.value
      })
      if (
        await this.getAggregateDataLedgerSheet({
          params: {
            year: this.year.value,
            supplierId: this.selectClientName.value,
            productIds: selectProductId ?? []
          }
        })
      ) {
        alert(this.$t('common.common_ledger-sheet-big-data-alert'))
      }
    }
  },
  watch: {
    // 選択された仕入先に対応した商品のみのリスト作成
    selectClientName: {
      deep: true,
      handler(newVal, oldVal) {
        this.selectProductName = []
        this.productSelectBoxInfo.productNameList =
          this.getProductListFromState()
            .map((ele) => {
              return {
                label: ele.nameJp,
                value: ele[this.productSelectBoxInfo.productId],
                supplierId: ele.supplierId
              }
            })
            .filter(function (product) {
              return product.supplierId == newVal.value
            })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.row-contents {
  margin-top: 0 !important;
}

.input-form {
  position: relative;
  min-height: 230px;

  &-button-left {
    position: absolute;
    bottom: 5px;
    right: 150px;
  }
  &-button {
    position: absolute;
    bottom: 5px;
    right: 10px;
  }
}
.inputFormStyle {
  width: 100%;
  height: 100%;
  font-size: 14px;
}

.searchAreaStyle {
  height: 65px;

  .titleStyle {
    font-size: 18px;
  }

  .honbunStyle {
    font-size: 14px;
  }

  .honbunStyle2 {
    font-size: 14px;
    height: 50px;
  }

  .selectBoxStyle {
    margin: 0px 16px 0px 63px !important;
  }
  .selectBoxStyle2 {
    margin: 0px 16px 0px 63px !important;
    width: 500px;
    height: 50px;
  }

  .textButtonStyle {
    margin: 0px 21px;
  }
}
</style>
